import { render, staticRenderFns } from "./ProductPopUp.vue?vue&type=template&id=1c19f09e&"
import script from "./ProductPopUp.vue?vue&type=script&lang=js&"
export * from "./ProductPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ProductPopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports